import loadable from '@loadable/component';

export const NotificationPreferencesPageLoadable = loadable(
  () => import('./NotificationPreferencesPage'),
  { resolveComponent: (module) => module.NotificationPreferencesPage },
);
